import * as yup from 'yup';

const schema = yup.object().shape({
  username: yup
    .string()
    .required()
    .trim(),
  password: yup
    .string()
    .min(8)
    .required()
    .trim()
});

export default schema;
